/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import Backbone from 'backbone';

import ModalView from '../views/ModalView';
import SpinnerView from '../views/SpinnerView';

/**
 * Shows a modal to the user based on a view thats passed in that is responsible
 * for
 * @param {Object} opts A config object that defines the content of the modal
 * @param {string} opts.title title that is displayed in the header of the modal
 * @param {Marionette.View} opts.view view that will render everything in the modal other than the header
 * @param {string} [opts.dialogClasses=null] classes that are added to the modal-dialog container
 * @param {boolean} [opts.disableBackdrop=false] whether to disable the background while modal is open
 * @param {boolean} [opts.disableClose=false] whether to hide the close button in the modal
 * @returns {Promise} A promise containing any data passed back from the modal
 * @example
 *
 * showModal({
 *  title: 'Add a New Note',
 *  view: new NoteModalView({
 *    model: this.model,
 *    managerRole: this.managerRole
 *  })
 * });
 * -> shows the NoteModalView in a modal, and returns a Promise<NewNoteData>
 */
export default async function showModal(opts) {
  const { title, view, dialogClasses, disableClose, disableBackdrop } = opts;
  const modalModel = new Backbone.Model({
    title,
    dialogClasses,
    disableClose,
    disableBackdrop,
  });

  return new Promise((resolve) => {
    const modal = new ModalView({
      view: new SpinnerView(),
      model: modalModel,
      resolve,
    });

    $('body').append(modal.render().$el);

    if (!view.model) {
      view.model = modalModel;
    }
    modal.getRegion('modalContent').show(view);
  });
}
